import {
  authenticatedGet,
  authenticatedPost,
  authenticatedPut,
  authenticatedDelete,
} from "../../api/authenticatedFetch";

const BASE = "/api/v1";

export const listSourceConnections = async (params = {}) => {
  return authenticatedGet(`${BASE}/source-connections`, params);
};

export const getSourceConnection = async (id) => {
  return authenticatedGet(`${BASE}/source-connections/${encodeURIComponent(id)}`);
};

export const createSourceConnection = async (body) => {
  return authenticatedPost(`${BASE}/source-connections`, body);
};

export const updateSourceConnection = async (id, body) => {
  return authenticatedPut(`${BASE}/source-connections/${encodeURIComponent(id)}`, body);
};

export const deleteSourceConnection = async (id) => {
  return authenticatedDelete(`${BASE}/source-connections/${encodeURIComponent(id)}`);
};

export const validateSourceConnection = async (id) => {
  return authenticatedPost(`${BASE}/source-connections/${encodeURIComponent(id)}/validate`, {});
};

export const getValidationHistory = async (id) => {
  return authenticatedGet(`${BASE}/source-connections/${encodeURIComponent(id)}/validation-history`);
};
